import { ModelInstance, BaseModel, ToFrontHook, ToBackHook } from './util';
import { File } from './file';

@ModelInstance({
  mappingFields: {
    id: 'id',
    file: 'file',
  },
  relation: {
    file: File,
  }
})
export class LeagueDocument extends BaseModel {
  id: number;
  file: File;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
